import axios from 'axios'

export default ({
    namespaced: true,
    state: {
        accountStatus: null,
        accountAmount: null,
        accountPeriods: null,
        accountPeriodsOwed: null,
        accountPeriodsCount: null,
        simbolicCuota: false
    },
    
    getters:{
        accountStatus(state){
            return state.accountStatus
        },
        accountAmount(state){
            return state.accountAmount
        },
        accountPeriods(state){
            return state.accountPeriods
        },
        accountPeriodsOwed(state){
            return state.accountPeriodsOwed
        },
        accountPeriodsCount(state){            
            return state.accountPeriodsCount
        },
        simbolicCuota(state){            
            return state.simbolicCuota
        }
    },

    mutations: {
        SET_ACCOUNT_STATUS(state, data) {
            state.accountStatus = data
        },
        SET_ACCOUNT_PERIODS(state, data) {
            state.accountPeriods = data
        },
        SET_ACCOUNT_PERIODS_OWED(state, data) {
            state.accountPeriodsOwed = data
        },
        SET_ACCOUNT_PERIODS_COUNT(state, data) {
            state.accountPeriodsCount = data
        },
        SET_ACCOUNT_AMOUNT(state, data) {
            state.accountAmount = data
        },
        SET_SIMB_CUOTA(state, data) {
            state.simbolicCuota = data
        }
    },

    actions: {
        async getAccountStatus({commit,dispatch}, page) {
            try {
                page = page ? page : 0
                let response = await axios.get('account-status', {
                    params: { page: page}
                })
                let new_obj= {}
                let rev_obj = Object.keys(response.data.data).reverse()
                let index = 0
                rev_obj.forEach(function(i) { 
                    new_obj[index] = response.data.data[i]
                    index++
                })
                response.data.data = new_obj
                commit('SET_ACCOUNT_STATUS', response.data)
                dispatch('checkSimbolicCuota', response.data.data)

            } catch (e) {
                console.log(e);
                dispatch('auth/setAuthErrors', e.response.data, { root: true })
                throw Error;
            }
        },
        async getUnpaidPeriods({commit,dispatch}) {
            try {
                let response = await axios.get('unpaid-periods')
                commit('SET_ACCOUNT_AMOUNT', response.data.amount)
                commit('SET_ACCOUNT_PERIODS', response.data.periods)
                commit('SET_ACCOUNT_PERIODS_COUNT', response.data.count)
                commit('SET_ACCOUNT_PERIODS_OWED', response.data.periods_owed)
            } catch (e) {
                dispatch('auth/setAuthErrors', e.response.data, { root: true })
                throw Error;
            }
        },
        checkSimbolicCuota({commit}, data) {
            let list = Object.values(data)
            let count = list.length -1
            for(let i = 0; i <count; i++) {
                if (list[i].codigo_concepto == "CUOT" && list[i].debe != "debe" ){
                    commit('SET_SIMB_CUOTA', false)
                    break;
                }
                if (list[i].codigo_concepto == "SIMB" && list[i].debe != "debe" ){
                    commit('SET_SIMB_CUOTA', true)
                    break;
                }
            }
        },
    }
})
